import {UPDATE_LOCALE} from '../types';

export default {
  updateLocale: (locale) => {
    return {type: UPDATE_LOCALE, locale}
  }
}